import React from 'react';
import {
  Input, List, Button, Spin,
} from 'antd';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus } from '@fortawesome/free-solid-svg-icons';

import Breadcrumb from '@common/containers/Breadcrumb';
import MainLayout from '@common/layouts/MainLayout';
import withAuth from '@common/hocs/withAuth';
import CenteredContent from '@common/components/ui/CenteredContent';

import AlarmRuleItem from './AlarmRuleItem';

import useDeviceAlarms from './useDeviceAlarms';
import styles from './DeviceAlarms.module.less';

function DeviceAlarms() {

  const { t } = useTranslation();
  const {
    deviceList,
    requestAlarms,
    onChangeSearch,
    search,
    loading,
    hasMore,
    goToCreate,
    loadingNext,
    breadcrumbData,
    setValueFilter,
    arrayFilter,
    isCreate
  } = useDeviceAlarms();

  return (
    <MainLayout applyPadding={false}>
      <div className={styles.wrapper}>
        <header className="bottom-shadow">
          <Breadcrumb breadcrumbData={breadcrumbData} />
        </header>

        <div className={styles.searchAndBtn}> 
          <Input
            placeholder={t('common.find_by_ruler')}
            className={styles.search}
            onChange={(e) => setValueFilter(e.target.value)} 
            suffix={<FontAwesomeIcon icon={faSearch} />}
            allowClear
          />
          {
            isCreate &&
            <Button className={styles.create_btn} type="primary" onClick={goToCreate}>
              <FontAwesomeIcon icon={faPlus} />
              {t('views.dynamic_alarms.buttons.create_inverters_rule')}
            </Button>
          } 
        </div>

        <div id="scrollable_alarms" className={styles.list}>
          <InfiniteScroll
            dataLength={arrayFilter ? arrayFilter.length : 0}
            scrollableTarget="scrollable_alarms"
            next={() => requestAlarms({ forNext: true })}
            hasMore={hasMore}
          >
            <List
              loading={loading}
              dataSource={arrayFilter || []}
              rowKey={(item) => item.id}
              renderItem={(item) => <AlarmRuleItem {...item} />}
              footer={(function () {

                if (!loadingNext) return null;
                return (
                  <CenteredContent>
                    <Spin />
                  </CenteredContent>
                );

              }())}
            />
          </InfiniteScroll>
        </div>
      </div>
    </MainLayout>
  );

}

export default withAuth(DeviceAlarms);
